module.exports = __webpack_public_path__ + "img/full6-min.55050fc1.png";